<h3 class="text-base--primary">Content Settings</h3>
<p class="text-description">Adjust and customize options for your selected content.</p>
<app-playlist-settings-content
    [visibleTabs]="['basics']"
    [showPlaylistTabs]="false"
    [showForTM]="true"
    (settingsChange)="onSettingsChange($event)" />
